import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';

export default function IndexDynamic() {
    return (
        <>
            <B />
            <C />
            <D />
            <E />
        </>
    );
}
